<template lang="pug">
  .unistar-campaign(v-loading="loading")
    .unistar-campaign__header
      el-breadcrumb(
        separator="/"
      )
        el-breadcrumb-item(
          :to="{ path: isVendor ? '/vendor-campaign/list' : '/unistar/list' }"
        ) {{ $t('项目列表') }}
        el-breadcrumb-item(
          v-if="!isVendor"
          :to="{ path: '/unistar/campaign-overview' }"
        ) {{ campaignInfo.campaign_name }}
        el-breadcrumb-item {{ sowInfo.sub_final_scope_name }}
      span(v-if="!isVendor" @click="$router.push('/unistar/campaign-overview')") < {{ $t('返回') }}
    .campaign__basic_info
      .campaign__name {{ campaignInfo.campaign_name }}
      .campaign__status(:class="[campaignStatusClass]") {{ $t(campaignStatus) }}
      .campaign__id {{ $t('项目') }}ID：{{ campaignInfo.campaign_id }}
    .campaign-process__sub
      template(v-for="item in sowList")
        el-tooltip(
          :content="item.sub_final_scope_name"
          placement="top"
        )
          .campaign-process__sub-item(
            :key="item.sub_final_scope_name"
            :class="{active: getActiveStatus(item)}"
            @click="onSOWClick(item)"
          ) {{ item.sub_final_scope_name }}
    el-card.unistar-campaign-container
      .unistar-campaign__process(v-if="showSubAndProcess")
        template(
          v-for="(item, i) in sowProcess"
        )
          process-item(
            :item="item"
            :index="i"
            @click="onPhaseChange(item)"
            :class="calcPhaseStatus(item)"
          )
          i.iconfont.icon-jiedianjiantou(
            v-if="i !== sowProcess.length - 1"
            :class="calcPhaseStatus(sowProcess[i + 1])"
          )
      .unistar-campaign__content
        router-view(
          :key="1"
          ref="routerView"
        )
</template>

<script>
// import axios from 'axios'
import ProcessItem from './components/ProcessItem'

export default {
  components: {
    ProcessItem
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('unistar/getCampaignInfo')
    if (this.sowInfo.type === this.$t('明星合作项目')) {
      this.$store.dispatch('unistar/getSOWList', true)
      this.$store.dispatch('unistar/getProcessTasks', {
        business_key: this.campaignId,
        business_type: this.sowInfo.business_type,
        phase_type: 1
      })
    }
    if (this.sowInfo.sub_final_scope_id) {
      this.$store.dispatch('unistar/getSOWList')
      this.$store.dispatch('unistar/getProcessTasks', {
        business_key: this.sowInfo.sub_final_scope_id,
        business_type: this.sowInfo.business_type,
        phase_type: 2
      })
    }
    this.loading = false
  },
  computed: {
    campaignStatusClass () {
      switch (this.campaignInfo.status) {
        case 3:
          return 'done'
        case 4:
          return 'stop'
        default:
          return ''
      }
    },
    campaignStatus () {
      switch (this.campaignInfo.status) {
        case 0:
          return this.$t('草稿')
        case 1:
          return this.$t('进行中')
        case 2:
          return this.$t('已失效')
        case 3:
          return this.$t('已完成')
        case 4:
          return this.$t('已终止')
      }
    },
    showSubAndProcess () {
      return !this.isVendor && !this.$route.fullPath.includes('participants')
    },
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    isCreator () {
      return this.$store.state.common.user.user_id === this.campaignInfo.brief.user_id
    },
    campaignId () {
      return this.$store.state.unistar.campaignInfo.campaign_id
    },
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    },
    sowList () {
      return this.$store.state.unistar.sowList
    },
    sowProcess () {
      return this.$store.state.unistar.sowProcess
    }
  },
  methods: {
    getActiveStatus (item) {
      if (this.sowInfo.sub_final_scope_id || this.sowInfo.sub_final_scope_id === null) {
        return this.sowInfo.sub_final_scope_id === item.sub_final_scope_id
      } else {
        return this.sowInfo.type === item.type
      }
    },
    onPhaseChange (item, i) {
      if (item.status !== '进行中' && item.status !== '已完成') {
        return
      }
      this.$router.push(item.action)
    },
    calcPhaseStatus (item) {
      return (item.status !== '进行中' && item.status !== '已完成') ? 'unistar-prepare-phase' : ''
    },
    async onSOWClick (item) {
      this.loading = true
      let route = 'sow-info'
      if (item.campaign_id) {
        route = 'campaign-info'
      }
      if (item.sub_final_scope_id) {
        await this.$store.dispatch('unistar/getSOWInfo', item.sub_final_scope_id)
        await this.$store.dispatch('unistar/getProcessTasks', {
          business_key: item.sub_final_scope_id,
          business_type: item.business_type,
          phase_type: 2
        })
      } else {
        this.$store.commit('unistar/setSOWInfo', item)
      }
      if (this.isVendor) {
        route = 'vendor-upload-quotation'
      }
      this.loading = false
      this.$router.push(route)
    }
  }
}
</script>

<style lang="stylus">
.campaign-process__sub
  margin-bottom -2px
  align-items center
  overflow visible
  .campaign-process__sub-item
    position relative
    overflow visible
.unistar-campaign
  height 100%
  .unistar-subFinalScope-titleBar
    position relative
    display flex
    align-items center
    justify-content space-between
    .title-bar
      width 100%
      margin-bottom 0
    .disabled
      cursor not-allowed
    .active
      cursor pointer
    i
      color $main
      margin-left 5px
    > div
      &:first-child
        > span
          font-size $font-large
          color #000
          &.disabled
            i
             color #808080
             cursor not-allowed
  .campaign-survey
    display flex
    margin 16px 0 18px
    align-items baseline
    > div
      display flex
      margin-right 40px
    .title
      font-size 20px
      font-weight 500
      margin-right 20px
      max-width 340px
      text-overflow ellipsis
      overflow hidden
      white-space nowrap
      display inline-block
    .status
      border-radius 9px
      background linear-gradient(to right, #41dcab, #83ded9)
      color #ffffff
      font-size 12px
      line-height 18px
      padding 0 3px
      margin-right 20px
      &.is-completed
        background linear-gradient(to right, #3370d2, #8dd1ea)
        color #ffffff
    .item
      font-size 12px
      color #808080
      > div:first-child
        margin-right 5px
.unistar-campaign__header
  display flex
  justify-content space-between
  align-items center
  font-size 12px
  > span
    color $main
    cursor pointer

  .campaign-tab
    height 31px
    overflow-y auto
    align-items flex-end
    width 100%
    .el-tabs__item
      max-width 180px
  .el-card
    flex 1
    .el-card__body
      padding-left 0
.unistar-campaign__sub
  display flex
  padding 10px 0 5px 0

.unistar-campaign__sub-item
  margin-right 10px
  transition all .3s ease-in-out
  border solid 1px #d4d8df
  border-radius 20px
  padding 5px 10px
  cursor pointer

.unistar-campaign__sub-item.active
.unistar-campaign__sub-item:hover
  box-shadow 0 1px 15px 1px #4ab7e2

.unistar-campaign
  position relative
  .el-table::before
    content none
.unistar-campaign__side__header
  height 40px
  margin-bottom 20px
  background #d7e7ef

.unistar-campaign__footer
  position absolute
  right 0
  padding 10px 0px 0px 10px
  .el-dropdown
    min-width 100px
    width 100px
  i
    font-size 12px
.campaign-tab__item
  width 180px
  overflow hidden
  white-space nowrap
  text-overflow ellipsis

.el-dropdown-menu__item
  &.selected
    color $main
    background #EDF8FC

.unistar-campaign
  .campaign__basic_info
    display flex
    margin 16px 0
    align-items center
    .campaign__name
      font-size 20px
      color #2c3031
      font-weight 600
    .campaign__status
      margin 0 22px
      height 18px
      line-height 18px
      font-size 12px
      border-radius 9px
      padding 0 10px
      color #fff
      background linear-gradient(to right, #41dcab, #83ded9)
    .campaign__status.done
      background linear-gradient(to right, #3370d2, #8dd1ea)
    .campaign__status.stop
      background linear-gradient(to right, #888888, #D9D9D9)
    .campaign__id
      color #808080
      font-size 12px
  .unistar-campaign__process
    display flex
    align-items center
    padding-left 18px
    border solid 1px #edf2fa
    .icon-jiedianjiantou
      text-align center
      color $main
      width 10px
      font-size 10px
    .unistar-prepare-phase
      cursor not-allowed
      color #999999
      .num
        color #999
        border-color #999
  .unistar-campaign-container > .el-card__body
    padding 0 !important
    .unistar-campaign__content
      padding 18px 32px !important
  .campaign-process__sub-item
    width unset
    min-width 125px
    padding 0 15px
    height 42px
    font-size 16px
    font-weight 600
    box-sizing border-box
    background-color #ffffff
    border-color #edf2fa
    color #66696a
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  .campaign-process__sub-item.active
    background-color #fff
    color #3370d2
    border-color #fff
    box-shadow 0 2px 8px 0 rgba(75, 79, 80, 0.08)
    border-bottom 2px solid #3370d2
  .title-bar
    background-color unset
    font-size 16px
    font-weight 600
    color #2c3031
    padding-left 0
    margin-bottom 0
  .info-display
    margin-bottom 10px
    font-size 14px
    .info_label
      color #999999
    .info_content
      color #5e5e5e
</style>
